import Error403Page from './Error403Page';
import { authModules } from 'app/auth';

const Error403PageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authModules.loggedin,
	routes: [
		{
			path: '/error403',
			element: <Error403Page />
		}
	]
};

export default Error403PageConfig;
